/**
 * Inline stroke-SVG, ärver currentColor. Aldrig emoji — de renderas olika på
 * Chromebook och ser inte ut som resten av gränssnittet.
 */
interface IconProps {
  size?: number;
  className?: string;
}

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
});

export const IconClock = ({ size = 17 }: IconProps) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);

export const IconCalendar = ({ size = 17 }: IconProps) => (
  <svg {...base(size)}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M8 2.5v4M16 2.5v4M3 10h18" />
  </svg>
);

export const IconWeek = ({ size = 17 }: IconProps) => (
  <svg {...base(size)}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M8 2.5v4M16 2.5v4M3 10h18M9.5 10v11M15 10v11" />
  </svg>
);

export const IconChecklist = ({ size = 17 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M4 7l2.5 2.5L11 5" />
    <path d="M4 17l2.5 2.5L11 13" />
    <path d="M14 7.5h6M14 17.5h6" />
  </svg>
);

export const IconSliders = ({ size = 17 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M4 8h10M18 8h2M4 16h4M12 16h8" />
    <circle cx="16" cy="8" r="2.2" />
    <circle cx="10" cy="16" r="2.2" />
  </svg>
);

export const IconBook = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M4 5.5A2 2 0 0 1 6 3.5h5v17H6a2 2 0 0 1-2-2z" />
    <path d="M20 5.5a2 2 0 0 0-2-2h-5v17h5a2 2 0 0 0 2-2z" />
  </svg>
);

export const IconLink = ({ size = 15 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M10.5 13.5a4 4 0 0 0 5.7 0l2.8-2.8a4 4 0 0 0-5.7-5.7l-1.4 1.4" />
    <path d="M13.5 10.5a4 4 0 0 0-5.7 0l-2.8 2.8a4 4 0 0 0 5.7 5.7l1.4-1.4" />
  </svg>
);

export const IconChat = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M20.5 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 20.5 12z" />
  </svg>
);

export const IconClose = ({ size = 16 }: IconProps) => (
  <svg {...base(size)} strokeWidth={2}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconChevronLeft = ({ size = 15 }: IconProps) => (
  <svg {...base(size)} strokeWidth={2}>
    <path d="M14.5 6l-6 6 6 6" />
  </svg>
);

export const IconChevronRight = ({ size = 15 }: IconProps) => (
  <svg {...base(size)} strokeWidth={2}>
    <path d="M9.5 6l6 6-6 6" />
  </svg>
);

export const IconPlus = ({ size = 15 }: IconProps) => (
  <svg {...base(size)} strokeWidth={2.2}>
    <path d="M12 5.5v13M5.5 12h13" />
  </svg>
);

export const IconCheck = ({ size = 12 }: IconProps) => (
  <svg {...base(size)} strokeWidth={3}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);

export const IconSend = ({ size = 15 }: IconProps) => (
  <svg {...base(size)} strokeWidth={2}>
    <path d="M5 12h13M12 5.5l6.5 6.5-6.5 6.5" />
  </svg>
);

export const IconStar = ({ size = 18 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8L3.5 9.7l5.9-.8z" />
  </svg>
);

export const IconUser = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <circle cx="12" cy="8.5" r="3.5" />
    <path d="M5 20c1.2-3.6 4-5.2 7-5.2s5.8 1.6 7 5.2" />
  </svg>
);

export const IconInfo = ({ size = 16 }: IconProps) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5M12 16.5v.5" />
  </svg>
);

export const IconEye = ({ size = 15 }: IconProps) => (
  <svg {...base(size)}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
    <circle cx="12" cy="12" r="2.8" />
  </svg>
);
